import { useNavigate } from 'react-router'
import React from 'react'
import Psychology from '@mui/icons-material/Psychology'
import LocalHospital from '@mui/icons-material/LocalHospital'
import Receipt from '@mui/icons-material/Receipt'
import CheckCircle from '@mui/icons-material/CheckCircle'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import {
  SupportHomePageContainer,
  SupportHomePageItem,
  TILE_COLORS,
  TileIconContainer,
  TileText,
} from 'src/supportPortal/views/home/styledComponents'
import useServerAuth from 'src/customHooks/useServerAuth'

export default function PractitionerManagementNavPage() {
  const navigate = useNavigate()
  const { allRolesInBoolean } = useServerAuth()
  
  return (
    <>
      <SupportHeader heading={'Practitioners & Service Providers'} showBackButton />
      <SupportHomePageContainer>
        {(allRolesInBoolean.isL1TherapySupport ||
          allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport) && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.therapists}
            onClick={() => navigate('/support-home/practitioner-management/therapists')}
          >
            <TileIconContainer>
              <Psychology />
            </TileIconContainer>
            <TileText>Therapists</TileText>
          </SupportHomePageItem>
        )}
        {allRolesInBoolean.isClinicSuccessManager && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.doctors}
            onClick={() => navigate('/support-home/practitioner-management/doctors')}
          >
            <TileIconContainer>
              <LocalHospital />
            </TileIconContainer>
            <TileText>Doctors</TileText>
          </SupportHomePageItem>
        )}
        {allRolesInBoolean.isL3TherapySupport && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.payoutReceipts}
            onClick={() => navigate('/support-home/practitioner-management/payout-receipts')}
          >
            <TileIconContainer>
              <Receipt />
            </TileIconContainer>
            <TileText>Payout Receipts</TileText>
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport) && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.serviceApprovals}
            onClick={() => navigate('/support-home/practitioner-management/service-approvals')}
          >
            <TileIconContainer>
              <CheckCircle />
            </TileIconContainer>
            <TileText>Service Approvals</TileText>
          </SupportHomePageItem>
        )}
      </SupportHomePageContainer>
    </>
  )
}

